import React from "react";

function PropertyEnumInput(props) {
  return (
    <>
      <p htmlFor={props.id} className="property-header">
        {props.title}
      </p>
      <select
        id={props.id}
        className="form-select"
        disabled={props.disabled}
        onChange={props.handler}
      >
        {props.values.map((item, index) => (
          <option
            key={index}
            value={item.value}
            selected={item.value === props.selectedValue ? "selected" : null}
          >
            {item.value}
          </option>
        ))}
      </select>
    </>
  );
}

export default PropertyEnumInput;
